exports.components = {
  "component---src-pages-diensten-tuinhuizen-tuinkantoren-js": () => import("./../../../src/pages/diensten/tuinhuizen-tuinkantoren.js" /* webpackChunkName: "component---src-pages-diensten-tuinhuizen-tuinkantoren-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-realisaties-js": () => import("./../../../src/pages/realisaties.js" /* webpackChunkName: "component---src-pages-realisaties-js" */),
  "component---src-templates-realisatie-js": () => import("./../../../src/templates/realisatie.js" /* webpackChunkName: "component---src-templates-realisatie-js" */)
}

